<template>
  <div class="mx-auto my-2">
    <v-card color="basil">
      <v-card-title class="text-left justify-left py-6">
        Courses
        <v-spacer></v-spacer>
        <v-btn v-if="canCreateCourse == true" class="teal white--text" depressed @click="AddCourse()">
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Course</span>
        </v-btn>
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="tabItem in tabItems" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
          <div v-if="tabItem == 'Non Accredited Courses'">
            <v-card class="mx-4" flat>
              <v-card-title>
                <v-layout class="pb-2 px-4" row wrap>
                  <v-flex class="px-2 my-2" lg4 md4 sm2 xl3 xs1>
                    <v-text-field
                        v-model="nonAccName"
                        append-icon="mdi-magnify"
                        hide-details
                        label="Search course name"
                        single-line></v-text-field>
                  </v-flex>
                  <v-flex class="px-2 my-2" lg4 md4 sm2 xl3 xs1>
                    <v-autocomplete
                        v-model="nonAccCpd"
                        :clearable="clearable"
                        :elevation="1"
                        :items="CPD_PROVIDERS"
                        :loading="cpdProviderLoading"
                        :searchable="searchable"
                        item-text="trainingCenterName"
                        item-value="id"
                        label="search course owners"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-data-table
                  :headers="nonAccreditedHeaders"
                  :items="nonAccreditedCourses.rows"
                  :loading="nonAccreditedLoading"
                  :options.sync="nonAccOptions"
                  :server-items-length="nonAccreditedCourses.count"
                  class="elevation-1"
                  loading-text="Loading... please wait">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-if="canViewCourse" v-slot:activator="{ on }">
                      <v-icon class="mr-2" style="color: teal" @click="viewCourse(item)" v-on="on">mdi-eye</v-icon>
                    </template>
                    <span>View Course</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-if="canEditCourse && !canAccreditCourse" v-slot:activator="{ on }">
                      <v-icon class="mr-2" style="color: teal" @click="editCourse(item, false)"
                              v-on="on">mdi-circle-edit-outline
                      </v-icon>
                    </template>
                    <span>Edit Course</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-if="canAccreditCourse" v-slot:activator="{ on }">
                      <v-icon class="mr-2" style="color: teal" @click="editCourse(item, true)"
                              v-on="on">mdi-circle-edit-outline
                      </v-icon>
                    </template>
                    <span>Accredit Course</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </div>
          <div v-if="tabItem == 'Accredited Courses'">
            <v-card class="mx-4" flat>
              <v-card-title>
                <v-flex class="px-2 my-2" lg4 md4 sm2 xl3 xs1>
                  <v-text-field
                      v-model="accName"
                      append-icon="mdi-magnify"
                      hide-details
                      label="Search course name"
                      single-line
                      style="padding-top: 0%; margin-top: 0%;"></v-text-field>
                </v-flex>
                <v-flex class="px-2 my-2" lg4 md4 sm2 xl3 xs1>
                  <v-autocomplete
                      v-model="accCpd"
                      :clearable="clearable"
                      :elevation="1"
                      :items="CPD_PROVIDERS"
                      :loading="cpdProviderLoading"
                      :searchable="searchable"
                      item-text="trainingCenterName"
                      item-value="id"
                      label="search course owners"
                  ></v-autocomplete>
                </v-flex>
              </v-card-title>
              <v-data-table
                  :headers="headers"
                  :items="accreditedCourses.rows"
                  :loading="accreditedLoading"
                  :options.sync="accOptions"
                  :server-items-length="accreditedCourses.count"
                  class="elevation-1"
                  loading-text="Loading... please wait">
                >
                <template v-slot:[`item.courseCode`]="{ item }">
                  <label for="item">
                    <barcode :height="50" v-bind:value="item.courseCode">
                      Sorry, rendering failed!
                    </barcode>
                  </label>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-if="canViewCourse" v-slot:activator="{ on }">
                      <v-icon class="mr-2" style="color: teal" @click="viewCourse(item)" v-on="on">mdi-eye</v-icon>
                    </template>
                    <span>View Course</span>
                  </v-tooltip>
                </template>
              </v-data-table>

            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="60%">
        <v-card>
          <v-card-title class="headline font-weight-regular blue-grey white--text" primary-title>{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdAddCourse v-if="dialog" :changeCourseOwnerNo="changeCourseOwnerNo"
                        :changeTCourseUsedNo="changeTCourseUsedNo"
                        :course="course" @close="closeDialog()"
                        @registerOrUpdateCourse="registerOrUpdateCourse"></HrdAddCourse>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="detailDialog" persistent width="60%">
        <v-card>
          <v-card-title class="headline font-weight-regular blue-grey white--text" primary-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-btn class="float-right" dark icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdDetailCourse v-if="detailDialog" :course="course"></HrdDetailCourse>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>


<script>
import HrdAddCourse from "./hrd-add-course";
import HrdDetailCourse from "./hrd-course-detail";
import {CourseServcie} from "./course.service";
import {getUser} from "@/utils/helper";
import VueBarcode from 'vue-barcode';
import {TrainingCenterService} from "@/components/TrainingCenter/training_center.service";

export default {
  components: {
    HrdAddCourse,
    HrdDetailCourse,
    'barcode': VueBarcode
  },

  data() {
    return {
      dialog: false,
      detailDialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      // Accredited
      accreditedLoading: false,
      accreditedCourses: [],
      accOptions: {
        page: 1,
        itemsPerPage: 10
      },
      accName: null,
      accCpd: null,
      headers: [
        {text: "Course Name", value: "courseName"},
        {text: "Course Code", value: "courseCode"},
        {text: "Continuing Education Unit(CEU)", value: "continualEducationUnit"},
        {text: "Course Owner", value: "courseOwner.trainingCenterName"},
        {text: "Course Accreditor", value: "courseAccreditor.accreditorName"},
        {text: "Accreditation Date", value: "courseAccreditationDate"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      // Non-Accredited
      nonAccreditedLoading: false,
      nonAccreditedCourses: [],
      nonAccOptions: {
        page: 1,
        itemsPerPage: 10
      },
      nonAccName: null,
      nonAccCpd: null,
      nonAccreditedHeaders: [
        {text: "Course Name", value: "courseName"},
        {text: "Continuing Education Unit(CEU)", value: "continualEducationUnit"},
        {text: "Course Owner", value: "courseOwner.trainingCenterName"},
        {text: "Course Creater", value: "createdBy.firstName"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      //
      CPD_PROVIDERS: [],
      course: null,
      title: "",
      loading: false,
      changeTCourseUsedNo: null,
      changeCourseOwnerNo: null,
      cpdProviderLoading: false,
      cpdProviderValue: null,
      tab: null,
      searchable: true,
      clearable: true,
      courseNameValue: null,
      tabItems: ["Non Accredited Courses", "Accredited Courses"],
    };
  },
  async beforeMount() {
    this.fetchAccreditedCourse();
    this.fetchNonAccreditedCourse();

    this.cpdProviderLoading = true;
    const trainingCenterResp = await TrainingCenterService.getTrainingCentersDrp();
    this.CPD_PROVIDERS = trainingCenterResp.data;
    this.cpdProviderLoading = false;
  },
  computed: {
    canCreateCourse() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Course" && permission.canCreate
      );
    },
    canEditCourse() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Course" && permission.canUpdate
      );
    },
    canViewCourse() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Course" && permission.canRead
      );
    },
    canAccreditCourse() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Course" && permission.canAccreditCourse
      );
    },
  },
  watch: {
    nonAccOptions: {
      handler() {
        this.fetchNonAccreditedCourse();
      },
      deep: true
    },
    accOptions: {
      handler() {
        this.fetchAccreditedCourse();
      },
      deep: true
    },
    nonAccName: function (val) {
      this.nonAccName = val == '' ? null : val;
      this.fetchNonAccreditedCourse();
    },
    accName: function (val) {
      this.accName = val == '' ? null : val;
      this.fetchAccreditedCourse();
    },
    nonAccCpd: function (val) {
      this.nonAccCpd = val == '' ? null : val;
      this.fetchNonAccreditedCourse();
    },
    accCpd: function (val) {
      this.accCpd = val == '' ? null : val;
      this.fetchAccreditedCourse();
    },
  },
  methods: {
    async fetchAccreditedCourse() {
      this.accreditedLoading = true;
      const {page, itemsPerPage} = this.accOptions;
      let searchParams = '?isAccredited=True';
      itemsPerPage > 0 && (searchParams += `&page=${page}&pageSize=${itemsPerPage}`);
      console.log(this.cpdProviderValue)
      this.accCpd !== null && (searchParams += '&trainingCenterId=' + this.accCpd);
      this.accName !== null && (searchParams += '&name=' + this.accName);
      const res = await CourseServcie.getCourses(searchParams);
      if (res.status === 200) {
        this.accreditedLoading = false;
        this.accreditedCourses = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching accredited course reports, Please try Again!"
        );
      }
    },
    async fetchNonAccreditedCourse() {
      this.nonAccreditedLoading = true;
      const {page, itemsPerPage} = this.nonAccOptions;
      let searchParams = '?isAccredited=False';
      itemsPerPage > 0 && (searchParams += `&page=${page}&pageSize=${itemsPerPage}`);
      this.nonAccCpd !== null && (searchParams += '&trainingCenterId=' + this.nonAccCpd);
      this.nonAccName !== null && (searchParams += '&name=' + this.nonAccName);
      const res = await CourseServcie.getCourses(searchParams);
      if (res.status === 200) {
        this.nonAccreditedLoading = false;
        this.nonAccreditedCourses = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching non accredited course reports, Please try Again!"
        );
      }
    },

    async fetchCourseList() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      console.log('page', page, 'itemsPerPage', itemsPerPage);
      let searchParams = '';
      this.cpdProviderValue !== null && (searchParams += '&trainingCenterId=' + this.cpdProviderValue);
      this.courseNameValue !== null && (searchParams += '&name=' + this.courseNameValue);

      const res = await CourseServcie.getCourseList(
          page,
          itemsPerPage,
          searchParams
      );
      if (res.status === 200) {
        this.loading = false;
        const returnedCorses = res.data;
        this.nonAccreditedCourses = returnedCorses.filter(course => {
          return course.isAccredited == false || course.isAccredited == true
        })
        this.courses = returnedCorses.filter(course => {
          return course.isAccredited == true
        })
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching courses, Please try Again!"
        );
      }
    },
    viewCourse(item) {
      this.course = item;
      this.detailDialog = true;
      this.title = "Course Detail";
    },
    AddCourse() {
      this.course = null;
      this.dialog = true;
      this.title = "Add Course";
    },
    editCourse(item, isAccrediting) {
      item.isAccrediting = isAccrediting;
      this.course = item;
      this.title = "Edit Course";
      this.dialog = true;
      this.changeTCourseUsedNo = 0;
      this.changeCourseOwnerNo = 0;
    },
    closeDialog() {
      this.dialog = false;
      this.detailDialog = false;
      this.fetchCourseList();
    },
    async registerOrUpdateCourse(course) {
      let res = null;

      if (course.editMode) {
        res = await CourseServcie.update(course.id, course);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to update course, please try again");
        }
      } else {
        res = await CourseServcie.create(course);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create course, please try again");
        }
      }
    }
  },
};
</script>
<style scoped>
.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}
</style>

